// cfgactions

<template>
  	<v-container fluid ma-0 pa-0>
        <v-row no-gutters>
        <v-col cols="12" class="pt-0">
        <v-card tile class="grey darken-3 overflow-hidden">
            <v-app-bar absolute dark dense color="blue-grey darken-2"
                scroll-target="#playground" elevate-on-scroll
            >
				<v-toolbar-title>Action Config</v-toolbar-title>
                <v-spacer></v-spacer>
				<v-btn small class="ml-3" color="primary" @click="newItem">New</v-btn>
                <v-spacer></v-spacer>
				<v-btn small class="ml-3" color="success" :disabled="!isDirty" @click="saveData">Save</v-btn>
	  		</v-app-bar>
            <v-sheet id="playground" class="grey darken-3 overflow-y-auto" max-height="800">
				<v-container fluid style="min-height: 800px;padding-top: 60px">
					<v-row align="center">
						<v-col cols="12" sm="1" class="pa-0 pt-1 pl-1">
                            <v-text-field class="ma-0 pa-0" background-color="grey darken-3" style="font-size: 9pt;"
								value="Name" dense solo hide-details readonly
                            ></v-text-field>
                        </v-col>
        				<v-col cols="12" sm="1" class="pa-0 pt-1 pl-1">
                            <v-text-field class="ma-0 pa-0" background-color="grey darken-3" style="font-size: 9pt;"
								value="Context" dense solo hide-details readonly
                            ></v-text-field>
                        </v-col>
						<v-col cols="12" sm="2" class="pa-0 pt-1 pl-1">
                            <v-text-field class="ma-0 pa-0" background-color="grey darken-3" style="font-size: 9pt;"
								value="Title" dense solo hide-details readonly reverse
                            ></v-text-field>
                        </v-col>
						<v-col cols="12" sm="2" class="pa-0 pt-1 pl-1">
                            <v-text-field class="ma-0 pa-0" background-color="grey darken-3" style="font-size: 9pt;"
								value="Action" dense solo hide-details readonly reverse
                            ></v-text-field>
                        </v-col>
						<v-col cols="12" sm="1" class="pa-0 pt-1 pl-1">
                            <v-text-field class="ma-0 pa-0" background-color="grey darken-3" style="font-size: 9pt;"
								value="Active" dense solo hide-details readonly reverse
                            ></v-text-field>
                        </v-col>
						<v-col cols="12" sm="1" class="pa-0 pt-1 pl-1">
                            <v-text-field class="ma-0 pa-0" background-color="grey darken-3" style="font-size: 9pt;"
								value="Pos" dense solo hide-details readonly reverse
                            ></v-text-field>
                        </v-col>
						<v-col cols="12" sm="1" class="pa-0 pt-1 pl-1">
                            <v-text-field class="ma-0 pa-0" background-color="grey darken-3" style="font-size: 9pt;"
								value="Icon" dense solo hide-details readonly reverse
                            ></v-text-field>
                        </v-col>
						<v-col cols="12" sm="1" class="pa-0 pt-1 pl-1">
                            <v-text-field class="ma-0 pa-0" background-color="grey darken-3" style="font-size: 9pt;"
								value="Color" dense solo hide-details readonly reverse
                            ></v-text-field>
                        </v-col>
						<v-col cols="12" sm="1" class="pa-0 pt-1 pl-1">
                            <v-text-field class="ma-0 pa-0" background-color="grey darken-3" style="font-size: 9pt;"
								value="NewTab" dense solo hide-details readonly reverse
                            ></v-text-field>
                        </v-col>
					</v-row>
					<v-row v-for="(item, index) in items" :key="index">
						<v-col cols="12" sm="1" class="pa-0 pt-1 pl-1">
							<v-text-field class="ma-0 pa-0" background-color="grey darken-2" height="20" style="font-size: 9pt;"
								v-model="item.name" dense solo hide-details autocomplete="off" @input="hasChanged"
                                :ref="'name_' + index" @keyup.enter="goNext($event, 'name', index)"
							></v-text-field>
						</v-col>
						<v-col cols="12" sm="1" class="pa-0 pt-1 pl-1">
							<v-text-field class="ma-0 pa-0" background-color="grey darken-2" height="20" style="font-size: 9pt;"
								v-model="item.context" dense solo hide-details autocomplete="off" @input="hasChanged"
                                :ref="'context_' + index" @keyup.enter="goNext($event, 'context', index)"
							></v-text-field>
						</v-col>
						<v-col cols="12" sm="2" class="pa-0 pt-1 pl-1">
							<v-text-field class="ma-0 pa-0" background-color="grey darken-2" height="20" style="font-size: 9pt;"
								v-model="item.title" dense solo hide-details autocomplete="off" @input="hasChanged"
                                :ref="'title_' + index" @keyup.enter="goNext($event, 'title', index)"
							></v-text-field>
						</v-col>
						<v-col cols="12" sm="2" class="pa-0 pt-1 pl-1">
							<v-text-field class="ma-0 pa-0" background-color="grey darken-2" height="20" style="font-size: 9pt;"
								v-model="item.action" dense solo hide-details autocomplete="off" @input="hasChanged"
                                :ref="'action_' + index" @keyup.enter="goNext($event, 'action', index)"
							></v-text-field>
						</v-col>
						<v-col cols="12" sm="1" class="pa-0 pt-1 pl-1">
						    <v-switch class="mt-1 ml-3"
                                v-model="item.active" dense solo hide-details color="blue-grey" @change="hasChanged"
                            ></v-switch>				
						</v-col>
						<v-col cols="12" sm="1" class="pa-0 pt-1 pl-1">
							<v-text-field class="ma-0 pa-0" background-color="grey darken-2" height="20" style="font-size: 9pt;"
								v-model="item.pos" dense solo hide-details autocomplete="off" @input="hasChanged"
                                :ref="'pos_' + index" @keyup.enter="goNext($event, 'pos', index)"
							></v-text-field>
						</v-col>
						<v-col cols="12" sm="1" class="pa-0 pt-1 pl-1">
							<v-text-field class="ma-0 pa-0" background-color="grey darken-2" height="20" style="font-size: 9pt;"
								v-model="item.icon" dense solo hide-details autocomplete="off" @input="hasChanged"
                                :ref="'icon_' + index" @keyup.enter="goNext($event, 'icon', index)"
							></v-text-field>
						</v-col>
						<v-col cols="12" sm="1" class="pa-0 pt-1 pl-1">
							<v-text-field class="ma-0 pa-0" background-color="grey darken-2" height="20" style="font-size: 9pt;"
								v-model="item.color" dense solo hide-details autocomplete="off" @input="hasChanged"
                                :ref="'color_' + index" @keyup.enter="goNext($event, 'color', index)"
							></v-text-field>
						</v-col>
						<v-col cols="12" sm="1" class="pa-0 pt-1 pl-1">
						    <v-switch class="mt-1 ml-3"
                                v-model="item.newtab" dense solo hide-details color="blue-grey" @change="hasChanged"
                            ></v-switch>				
						</v-col>
					</v-row>
		  		</v-container>
			</v-sheet>
		</v-card>
        <v-overlay absolute :value="loading">
        	<v-progress-circular indeterminate size="64" width="7" color="cyan darken-4"></v-progress-circular>
        </v-overlay>
        </v-col>
        </v-row>
	</v-container>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
    name: 'cfgactions',
    components: {
    },
    props: {
    },
    data: () => ({
        loading: false,
        isDirty: false,
        items: [],
        toptions: JSON.parse('["table", "other"]'),
        day: 1,
    }),
    computed: {
        ...mapGetters({
            cfgactions: 'cfgactions/getCfgActions',
        }),
    },
    mounted() {
		this.fetchData()
    },
    methods: {
        fetchData() {
            this.loading = true
            let self = this
            this.$store.dispatch('cfgactions/getCfgActions')
            .then((response) => {
                //console.log(this.cfglists)
                this.items = JSON.parse(JSON.stringify(this.cfgactions))
                self.loading = false
            })
            .catch((error) => {
                console.log(error)
                self.loading = false
            });
        },
        hasChanged() {
            this.isDirty = true
            //console.log(this.items)
        },
        newItem() {
            this.items.push({ id: 0 })
        },
        saveData() {
			this.loading = true	
            console.log(this.items)
            let param = {
                cfgactions: this.items,
            }
            let self = this
            this.$store.dispatch('cfgactions/updateCfgActions', param)
            .then((response) => {
                //console.log(response)
                self.isDirty = false
                self.loading = false
		        this.fetchData()
            })
            .catch((error) => {
                console.log('CfgActions->submit->error')
                console.log(error)
                self.loading = false
            });
        },
        goNext(e, ref, idx) {
            console.log(e, ref, idx)
            //this.$nextTick(() => {
                let nidx = idx + 1
                if(!this.$refs[ref + '_' + nidx]) nidx = 0
                const nextInput = this.$refs[ref + '_' + nidx]
                if (nextInput) {
                    const inputEl = nextInput[0].$el.querySelector('input')
                    //nextInput[0].focus()
                    inputEl.focus()
                    inputEl.select()
                }
            //});
        },
    },
    watch: {
    },
}
</script>

<style>
.text-black .v-text-field__slot input {
   color: #000 !important;
}
</style>